/* eslint-disable no-shadow */
import Vue from 'vue'
import { logEventTypes } from '@/store/modules/logEvents'

const getDefaultState = () => ({
  reflectionContent: {
    description: '',
    header: '',
    goals: [],
    numUserPlacedComponents: null,
    reflections: [],
    simType: '',
    status: '',
    subtitle: '',
    title: '',
    titleIcon: '',
    suggestions: ''
  },
  isReflectionDialogActive: false,
  suggestions: '' // Add suggestions property to the default state
})

const state = getDefaultState()
const getters = {
  reflectionContent: (state) => state.reflectionContent,
  suggestions: (state) => state.suggestions,
  hasReflectionContentBeenSet: (state) => !!state.reflectionContent.title && !!state.reflectionContent.subtitle,
  isReflectionDialogActive: (state) => state.isReflectionDialogActive
}
const actions = {
  setReflectionContent: async ({ commit, dispatch }, reflectionContent) => {
    await dispatch('addLogEvent', { type: logEventTypes.SET_REFLECTION_CONTENT, content: reflectionContent })
    commit('setReflectionContent', reflectionContent)
  },
  setSuggestions: async ({ commit, dispatch }, suggestions) => {
    // await dispatch('addLogEvent', { type: logEventTypes.SET_REFLECTION_CONTENT, content: reflectionContent })
    commit('setSuggestions', suggestions)
  },
  activateReflectionDialog: ({ commit, dispatch }) => {
    commit('activateReflectionDialog')
    dispatch('addLogEvent', { type: logEventTypes.ACTIVATE_REFLECTION_DIALOG })
    console.log('activateReflectionDialog')
  },
  deactivateReflectionDialog: ({ commit, dispatch }) => {
    // Log the deactivation event before changing state
    dispatch('addLogEvent', { type: logEventTypes.DEACTIVATE_REFLECTION_DIALOG })
    commit('deactivateReflectionDialog')
    console.log('deactivateReflectionDialog')
  },
  destroyReflection({ commit, dispatch }) {
    // Log the destroy event before changing state
    dispatch('addLogEvent', { type: logEventTypes.DESTROY_REFLECTION })
    commit('destroyReflection')
    console.log('destroyReflection')
  }
}
const mutations = {
  activateReflectionDialog: (state) => {
    state.isReflectionDialogActive = true
  },
  deactivateReflectionDialog: (state) => {
    // TODO: make content available after dialog is muted
    state.isReflectionDialogActive = false
    // Object.assign(state, getDefaultState())
  },
  setReflectionContent: (state, payload) => {
    Vue.set(state, 'reflectionContent', payload)
  },
  setSuggestions: (state, payload) => {
    // Use direct assignment instead of Vue.set since the property exists in the state
    state.suggestions = payload
  },
  destroyReflection: (state) => {
    Object.assign(state, getDefaultState())
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
